import React, { useState } from 'react';
import { Modal } from 'antd';
import { ZoomIn, X } from 'lucide-react';

interface ImagePreviewProps {
    src: string;
    alt?: string;
    className?: string;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ src, alt = "Preview", className = "" }) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!src) return null;

    return (
        <>
            <div
                className={`relative group cursor-pointer ${className}`}
                onClick={() => setIsOpen(true)}
            >
                <img
                    src={src}
                    alt={alt}
                    className="w-full h-full object-cover rounded-lg"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all rounded-lg flex items-center justify-center">
                    <ZoomIn className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
            </div>

            <Modal
                open={isOpen}
                onCancel={() => setIsOpen(false)}
                footer={null}
                width="90vw"
                style={{ maxWidth: 1200, top: 20 }}
                styles={{ body: { padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#000' } }}
                closeIcon={<X className="w-5 h-5 text-white" />}
            >
                <img
                    src={src}
                    alt={alt}
                    className="max-w-full max-h-[85vh] object-contain"
                />
            </Modal>
        </>
    );
};

export default ImagePreview;
